import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// SELDON_BEATTIE_UPDATE_ATTACHMENT

const mutation = gql`
  mutation wellnessSeldonBeattieFormUpdateAttachment(
    $id: ID!
    $attachment: AnnualPhysicalFormUpdateAttachmentInput!
  ) {
    wellnessSeldonBeattieFormUpdateAttachment(
      id: $id
      attachment: $attachment
    ) {
      id
      form_attachment {
        id
        title
        notes
      }
    }
  }
`
export default function useWellnessUpdateAttachment() {
  const { onMutate: onWellnessAttachmentUpdate, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'wellnessSeldonBeattieFormUpdateAttachment',
    successMessage: 'Attachment updated'
  })

  return { onWellnessAttachmentUpdate, loading }
}
